import type { GwPickRow, LeagueAllResult } from 'api/league'

const CACHE_KEY_PREFIX = 'fpl_insights'

export interface CachedInsights extends LeagueAllResult {
  timestamp: number
  /** User squad picks for this GW (element + FPL multiplier: 1 bench, 2 captain, 3 triple captain) */
  userGwPicks?: GwPickRow[]
  /** @deprecated use userGwPicks */
  userPickElementIds?: number[]
  viewer_in_league?: boolean
}

export function buildCacheKey(
  userId: number,
  leagueId: number,
  gw: number,
  excludedPlayerIds: number[],
  excludedTeamIds: number[],
): string {
  const players = [...excludedPlayerIds].sort((a, b) => a - b).join(',')
  const teams = [...excludedTeamIds].sort((a, b) => a - b).join(',')
  return `${CACHE_KEY_PREFIX}_${userId}_${leagueId}_${gw}_${players}_${teams}`
}

export function getCachedInsights(key: string): CachedInsights | null {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as CachedInsights
  } catch {
    return null
  }
}

export function setCachedInsights(
  key: string,
  data: LeagueAllResult & { userGwPicks?: GwPickRow[]; userPickElementIds?: number[] },
): void {
  try {
    const entry: CachedInsights = { ...data, timestamp: Date.now() }
    localStorage.setItem(key, JSON.stringify(entry))
  } catch {
    // storage quota exceeded or unavailable — fail silently
  }
}

export function clearUserInsightsCache(userId: number): void {
  const prefix = `${CACHE_KEY_PREFIX}_${userId}_`
  const keysToRemove: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && key.startsWith(prefix)) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach(k => localStorage.removeItem(k))
}
